export default __webpack_public_path__ + "f4aabe998e70de559f756d0a665d5284.png";